import config from '@/config';
import Base from './base';

const host = config.API_URL;

function buildURL({ projectCode, substationCode, agentCode, deviceType, modbusAddress }) {
  let path = `api/v3/projects/${projectCode}/substations/${substationCode}/agents/${agentCode}`;
  if (modbusAddress) {
    path = `${path}/devices/${deviceType}/${modbusAddress}`;
  } else {
    path = `${path}/device/${deviceType}`;
  }
  return `${host}/${path}`;
}

export default {
  get({ projectCode, substationCode, agentCode, deviceType, modbusAddress, ...options }) {
    return Base(
      buildURL({
        projectCode,
        substationCode,
        agentCode,
        deviceType,
        modbusAddress
      })
    ).get(options);
  },
  delete(options) {
    return Base(buildURL(options)).delete();
  }
};
